// AMDiris Role-Based Access Control
// Roles: super_admin, admin, cra, crc, doctor, sponsor, investigator, monitor, data_manager

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  cra: "CRA (Monitor)",
  crc: "Clinical Research Coordinator",
  doctor: "Doctor / Investigator",
  sponsor: "Sponsor",
  investigator: "Doctor / Investigator",
  monitor: "Monitor",
  data_manager: "Data Manager",
};

// Sponsor & Doctor: NO downloads
export const canDownload = (role) =>
  !["sponsor", "doctor", "investigator"].includes(role);

// Sponsor: dashboard only
export const isSponsor = (role) => role === "sponsor";

// Doctor: dashboard + own studies/subjects view
export const isDoctor = (role) => role === "doctor";

// CRA: view & checking access only
export const isCRA = (role) => ["cra", "monitor"].includes(role);

// CRC: subject + visit + data entry functions
export const isCRC = (role) => role === "crc";

// Admin: full access
export const isAdmin = (role) => ["admin", "super_admin"].includes(role);

// Can create/edit study-level data
export const canManageStudies = (role) =>
  ["admin", "super_admin"].includes(role);

// Can edit subjects/visits/data
export const canEnterData = (role) =>
  ["admin", "super_admin", "crc", "doctor", "investigator", "data_manager"].includes(role);

// Can manage queries
export const canManageQueries = (role) =>
  ["admin", "super_admin", "cra", "monitor", "data_manager", "crc"].includes(role);

// Can see audit trail
export const canViewAudit = (role) =>
  ["admin", "super_admin", "cra", "monitor"].includes(role);

// Can manage users
export const canManageUsers = (role) =>
  ["admin", "super_admin"].includes(role);

// Sidebar nav allowed paths per role
export const allowedNavPaths = (role) => {
  if (isSponsor(role)) return []; // sponsor uses custom study-tab nav, no global paths (auto-redirected to their bound study)
  if (isDoctor(role) || role === "investigator") return []; // doctor uses custom study-tab nav, no global paths
  if (isCRA(role)) return ["/dashboard", "/studies", "/ecrf-builder", "/data-entry", "/queries", "/audit-trail"];
  if (isCRC(role)) return ["/dashboard", "/studies", "/data-entry", "/queries"];
  // admin / super_admin / data_manager
  return null; // null = all
};

// Tabs the doctor/investigator can see inside their bound study
export const DOCTOR_STUDY_TABS = ["overview", "subjects", "dataentry", "protocols", "ethics"];

// Doctor's CRF builder is read-only (cannot add/edit/delete sections)
export const canEditCRFBuilder = (role) =>
  ["admin", "super_admin", "data_manager"].includes(role);
